import { useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import "./StatusBar.css";
import NavigateTo from "../utils/NavigateTo";

/**
 * StatusBar — VS Code blue bottom bar.
 * Shows: branch, errors/warnings, encoding, language, theme toggle, line info.
 */
function StatusBar({ terminalOpen, setTerminalOpen }) {
  const { locale, setLocale, theme, toggleTheme, t } = useApp();
  const { pathname } = useLocation();

  const branch = "main";
  const lang = pathname.endsWith(".json") ? "JSON" : "JavaScript JSX";

  return (
    <div className="status-bar">
      {/* Left section */}
      <div className="status-bar__left">
        {/* <StatusItem icon="⎇" label={branch} title="Source Control" />
        <StatusItem icon="⚠" label="0" title="0 warnings" />
        <StatusItem icon="✕" label="0" title="0 errors" /> */}
        <span className="status-item status-text">{t("footer.tagline")}</span>
      </div>

      {/* Right section */}
      <div className="status-bar__right">
        {/* <StatusBtn
          onClick={() => setTerminalOpen((v) => !v)}
          title="Toggle Terminal"
          label={terminalOpen ? "⊟ Terminal" : "⊞ Terminal"}
        />
        <StatusItem label="Ln 1, Col 1" title="Go to Line/Column" />
        <StatusItem label="Spaces: 2" title="Indentation" />
        <StatusItem label="UTF-8" title="Select Encoding" />
        <StatusItem label="CRLF" title="Select End of Line Sequence" /> */}
        {/* <StatusItem label={lang} title="Select Language Mode" /> */}
        <StatusBtn
          label="GitHub"
          onClick={(e) => NavigateTo(e, "https://github.com/Tommy-BOU")}
          title="GitHub Link"
        />
        <StatusBtn
          label="Linkedin"
          onClick={(e) =>
            NavigateTo(
              e,
              "https://www.linkedin.com/in/tommy-boubaker-82b02381/",
            )
          }
          title="Linkedin Link"
        />
        <StatusBtn
          onClick={() => setLocale(locale === "en" ? "fr" : "en")}
          label={locale === "en" ? "🌐 EN" : "🌐 FR"}
          title="Toggle Language"
        />
        <StatusBtn
          onClick={() => toggleTheme()}
          label={theme === "dark" ? "☾ Dark+" : "☀ Light+"}
          title="Color Theme"
        />
      </div>
    </div>
  );
}

function StatusItem({ icon, label, title }) {
  return (
    <span className="status-item" title={title}>
      {icon && <span className="status-item__icon">{icon}</span>}
      {label}
    </span>
  );
}

function StatusBtn({ label, title, onClick }) {
  return (
    <button
      className="status-item status-item--btn"
      title={title}
      onClick={onClick}
    >
      {label}
    </button>
  );
}

export default StatusBar;
